import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconOpenQuote2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="open-quote-2, blockquote"><path d="M13.75 19.25H21.25V10.9643H17.75V4.75C17.75 4.75 13.75 6.30357 13.75 10.9643V19.25Z" stroke="currentColor" strokeWidth="1.5"/><path d="M2.75 19.25H10.25L10.25 10.9643H6.75L6.75 4.75C6.75 4.75 2.75 6.30357 2.75 10.9643L2.75 19.25Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconOpenQuote2;
